// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"4ab1e15a9e5c3087","3406":"58acde2104bbe5aa","4997":"ad74bb381f05bfb5","5405":"84dfe84765b8a3a3"}[chunkId] + ".css";
};